import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import logo from "../Assets/logo.png";

const Header = ({ setRole }) => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [isDropdownVisiblen, setDropdownVisiblen] = useState(false);
  const [isDropdownVisibleDownload, setDropdownVisibleDownload] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState("guest");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();
  const menuRef = useRef();
  const dropdownRef = useRef();
  const dropdownRefNews = useRef();
  const dropdownRefDownload = useRef();

  const dropdown_toggle = () => {
    menuRef.current.classList.toggle("nav-menu-visible");
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const loggedInStatus = localStorage.getItem("isLoggedIn");
    const role = localStorage.getItem("role");
    if (loggedInStatus === "true") {
      setIsLoggedIn(true);
      setUserRole(role || "guest");
    }
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 500);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const closeDropdown = () => {
    setDropdownVisible(false);
    setDropdownVisiblen(false);
    setDropdownVisibleDownload(false);
    menuRef.current.classList.remove("nav-menu-visible");
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        dropdownRefNews.current &&
        !dropdownRefNews.current.contains(event.target) &&
        dropdownRefDownload.current &&
        !dropdownRefDownload.current.contains(event.target)
      ) {
        setDropdownVisible(false);
        setDropdownVisiblen(false);
        setDropdownVisibleDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    localStorage.setItem("isLoggedIn", "false");

    setRole(null);
    navigate("/");
  };

  return (
    <header className="header">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>

      {/* Hamburger / Close Icon */}
      <div className="nav_dropdown" onClick={dropdown_toggle}>
        {menuOpen ? "✖" : "☰"}
      </div>

      <ul ref={menuRef} className="nav-links">
        <li>
          <Link to="/" onClick={closeDropdown}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/1m" onClick={closeDropdown}>
            Message
          </Link>
        </li>

        {!isMobile && (
          <>
            {/* Services Dropdown */}
            <li
              className="dropdown"
              onMouseEnter={() => setDropdownVisible(true)}
              onMouseLeave={() => setDropdownVisible(false)}
            >
              <Link to="/services" onClick={closeDropdown}>
                Services
              </Link>
              {isDropdownVisible && (
                <ul ref={dropdownRef} className="dropdown-menu">
                  <li>
                    <Link to="/services/web-development" onClick={closeDropdown}>
                      🌐 Web Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/app-development" onClick={closeDropdown}>
                      📱 Mobile APP Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/dashboard" onClick={closeDropdown}>
                      📊 Data Analysis Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/tutorial" onClick={closeDropdown}>
                      🎓 Tutorials
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/electrical" onClick={closeDropdown}>
                      ⚡ Electrical Consultancy
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* News Dropdown */}
            <li
              className="dropdown"
              onMouseEnter={() => setDropdownVisiblen(true)}
              onMouseLeave={() => setDropdownVisiblen(false)}
            >
              <Link to="/news" onClick={closeDropdown}>
                News
              </Link>
              {isDropdownVisiblen && (
                <ul ref={dropdownRefNews} className="dropdown-menu">
                  <li>
                    <Link to="/news/technology" onClick={closeDropdown}>
                      Technology
                    </Link>
                  </li>
                  <li>
                    <Link to="/news/t1" onClick={closeDropdown}>
                      ADD Technology
                    </Link>
                  </li>
                  <li>
                    <Link to="/news/economics" onClick={closeDropdown}>
                      Economics
                    </Link>
                  </li>
                  <li>
                    <Link to="/news/e1" onClick={closeDropdown}>
                      ADD Economics
                    </Link>
                  </li>
                  <li>
                    <Link to="/news/sport" onClick={closeDropdown}>
                      Sport
                    </Link>
                  </li>
                  <li>
                    <Link to="/news/s1" onClick={closeDropdown}>
                      ADD Sport
                    </Link>
                  </li>
                  <li>
                    <Link to="/news/others" onClick={closeDropdown}>
                      Others
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <Link to="/contact" onClick={closeDropdown}>
                Contact
              </Link>
            </li>

            {/* Download Dropdown */}
            <li
              className="dropdown"
              onMouseEnter={() => setDropdownVisibleDownload(true)}
              onMouseLeave={() => setDropdownVisibleDownload(false)}
            >
              <Link to="/download" onClick={closeDropdown}>
                Download
              </Link>
              {isDropdownVisibleDownload && (
                <ul ref={dropdownRefDownload} className="dropdown-menu">
                  <li>
                    <Link to="/download/download" onClick={closeDropdown}>
                      📥 View Downloads
                    </Link>
                  </li>
                  <li>
                    <Link to="/download/d1" onClick={closeDropdown}>
                      ➕ Add Download
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <button onClick={handleLogout} className="logout-btn">
                Logout
              </button>
            </li>
          </>
        )}

        {/* Mobile View Links */}
        {isMobile && (
          <>
            <li>
              <Link to="/contact" onClick={closeDropdown}>
                Contact
              </Link>
            </li>
            <li>
              <Link to="/downloads/download" onClick={closeDropdown}>
                📥 View Downloads
              </Link>
            </li>
            <li>
              <Link to="/downloads/d1" onClick={closeDropdown}>
                ➕ Add Download
              </Link>
            </li>
            <li>
              <button onClick={handleLogout} className="logout-btn">
                Logout
              </button>
            </li>

            <li className="section-title">— Our Basic Services —</li>
            <li>
              <Link to="/services/web-development" onClick={closeDropdown}>
                🌐 Web Development
              </Link>
            </li>
            <li>
              <Link to="/services/app-development" onClick={closeDropdown}>
                📱 Mobile APP Development
              </Link>
            </li>
            <li>
              <Link to="/services/dashboard" onClick={closeDropdown}>
                📊 Data Analysis Dashboard
              </Link>
            </li>
            <li>
              <Link to="/services/tutorial" onClick={closeDropdown}>
                🎓 Tutorials
              </Link>
            </li>
            <li>
              <Link to="/services/electrical" onClick={closeDropdown}>
                ⚡ Electrical Consultancy
              </Link>
            </li>

            <li className="section-title">— Latest News —</li>
            <li>
              <Link to="/news/technology" onClick={closeDropdown}>
                Technology
              </Link>
            </li>
            <li>
              <Link to="/news/t1" onClick={closeDropdown}>
                ADD Technology
              </Link>
            </li>
            <li>
              <Link to="/news/economics" onClick={closeDropdown}>
                Economics
              </Link>
            </li>
            <li>
              <Link to="/news/e1" onClick={closeDropdown}>
                ADD Economics
              </Link>
            </li>
            <li>
              <Link to="/news/sport" onClick={closeDropdown}>
                Sport
              </Link>
            </li>
            <li>
              <Link to="/news/s1" onClick={closeDropdown}>
                ADD Sport
              </Link>
            </li>
            <li>
              <Link to="/news/others" onClick={closeDropdown}>
                Others
              </Link>
            </li>
          </>
        )}
      </ul>
    </header>
  );
};

export default Header;
